import React from "react";
import { ArrowUpRight } from "lucide-react";

const DIAL = { green: "#22E0A1", amber: "#FFC726", red: "#FF5C7A" };
const FEATURED = ["ABC Highway", "Bridgetown Central"];

const CorridorHotspots = ({ corridors = [], onNavigate }) => {
  if (!corridors.length) return null;

  const featured = FEATURED.map((n) => corridors.find((c) => c.name === n)).filter(Boolean);
  const rest = corridors
    .filter((c) => !FEATURED.includes(c.name))
    .sort((a, b) => b.delay_minutes - a.delay_minutes)
    .slice(0, Math.max(0, 4 - featured.length));
  const list = [...featured, ...rest];

  return (
    <section className="mt-7" data-testid="corridor-hotspots">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="font-head text-sm font-bold uppercase tracking-wide text-[#67799A]">Corridor hotspots</h3>
        <span className="flex items-center gap-1.5 text-xs font-semibold text-[#22E0A1]">
          <span className="go-blip inline-block h-1.5 w-1.5 rounded-full bg-[#22E0A1]" /> Live
        </span>
      </div>

      <div className="go-card overflow-hidden rounded-3xl">
        {list.map((c, i) => {
          const col = DIAL[c.dial] || DIAL.amber;
          const pct = Math.round(Math.min(1, c.congestion_index || 0) * 100);
          return (
            <button
              key={c.name}
              onClick={() => onNavigate && onNavigate(c.name)}
              className={`flex w-full items-center gap-3.5 px-4 py-3.5 text-left transition-colors active:bg-white/5 ${i ? "border-t border-white/[0.06]" : ""}`}
              data-testid={`corridor-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: col, boxShadow: `0 0 8px ${col}` }} />
              <div className="min-w-0 flex-1">
                <div className="truncate font-head text-[15px] font-bold text-white">{c.name}</div>
                <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-white/10">
                  <div className="h-full rounded-full" style={{ width: `${pct}%`, background: col, transition: "width 0.6s ease" }} />
                </div>
              </div>
              <div className="shrink-0 text-right">
                <div className="font-head text-base font-extrabold" style={{ color: col }}>+{Math.round(c.delay_minutes)}m</div>
                <div className="text-[11px] font-semibold text-[#67799A]">{c.status}</div>
              </div>
              <ArrowUpRight size={16} className="shrink-0 text-[#3E4E6B]" />
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default CorridorHotspots;
